import { defineMessages } from 'react-intl';

export default defineMessages({
    everything: {
        id: 'cpmi-accountDropdown.directives.ProducerCodeSelectDirective.ProducerCodeSelect.Everything',
        defaultMessage: 'All Locations'
    },
    workStartedByMe: {
        id: 'cpmi-accountDropdown.directives.ProducerCodeSelectDirective.ProducerCodeSelect.Work started by me',
        defaultMessage: 'Work started by me'
    }
});
